'use strict';
var emailSchema = require('./email-schema');

function makeForgotUsernameSchema() {
  return {
    email: emailSchema.email
  };
}
module.exports = makeForgotUsernameSchema;
